import type { FormValues, MetaValues } from '@/types/form';
import { getSubmitFormValues } from './getFormFormatedValues';

export const submitForm = async (
  value: FormValues,
  meta: MetaValues,
  isChineseForm?: boolean,
) => {
  const formData = new FormData();
  const mutatedValues = getSubmitFormValues(value, meta);

  for (const [key, val] of Object.entries(mutatedValues)) {
    formData.append(key, val as string);
  }

  const url =
    isChineseForm ?
      import.meta.env.PUBLIC_CONTACT_CHINA_FORM_LAMBDA_URL
    : import.meta.env.PUBLIC_CONTACT_FORM_LAMBDA_URL;
  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  });

  const message = await response.text();

  if (!response.ok) {
    window.posthog.captureException(new Error(message), {
      $exception_fingerprint: 'FormSubmissionError',
      $formData: {
        ...mutatedValues,
      },
    });

    return Promise.reject(message);
  }

  return message;
};
